import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales Enablement is the key:" />

      <nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/&amp;title=Sales%20Enablement%20is%20the%20key%3A&amp;summary=Sales%20Enablement%20is%20the%20key%3A&amp;source=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20Enablement%20is%20the%20key%3A&amp;url=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20Enablement%20is%20the%20key%3A&amp;body=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-connect-lock-key.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Sales Enablement is the key:</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>23 April 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>If you are currently running or overseeing a B2B sales force, and finding the following challenges then you are not alone:</h3>
<ul><li>Declining sales results and productivity outputs<br/></li><li>Increasing customer expectations – and corresponding increase in cost of sales.<br/></li><li>Increased competitive activity – and decreased revenue/margin per deal.<br/></li><li>Increased sales staff attrition – declining average tenure.</li><li>Increase % of sales force now under-performing.</li></ul>
<div className="rich-text"><p>Sadly, most B2B businesses (globally) are suffering the ill effects of this new customer-led era, where technology is increasingly enabling customers to SELF-SERVE. No surprise that so many vendor businesses are wondering why sales output is declining...in the words of Meatloaf, "the future just ain't what it used to be".<br/></p><p>Yes, I know that everyone is now saying that sales has changed, but the more important question is what to do to address this change. The undeniable truth is that businesses must transform, but where do we start? This is a massive topic of a single post (which is why I wrote the book – Sales Transformation) but let’s start with a simple and pragmatic step that is meaningful, feasible and appropriate to most sales related businesses.</p><h3><strong>Establish a standalone Sales Enablement (SE) function and associated charter.</strong></h3><p>CSO Insights neatly defines SE as:<em> </em></p></div>
<aside className="pull-quote">
    <blockquote>
        <p>&quot;a strategic, cross-functional discipline designed to increase sales results and productivity by providing integrated content, training, and coaching services for salespeople and front-line sales managers along the entire customer’s journey, powered by technology”</p>
    </blockquote>
</aside>

<div className="rich-text"><p>With over 20 years of sales research experience <a href="http://www.csoinsights.com/">CSO Insights</a> is one of the global leaders in research and thought leadership for B2B sales organisations. Having just released their 2016 Sales Enablement Optimization Study – CSO asked its participants what their number one objective was for 2016, and what do you know, “increasing revenues” was the top response and was cited by 68% of the study participants. For me, it seriously beggars’ belief why so many businesses continually expect "more revenue" each year, but so few are actually prepared to invest the $$ required to address some of the root causes of the implied under-performance.</p></div>
<img alt="Dr Evil" className="img-responsive" height="361" src="../../../media/images/2.width-647.png" width="500"/>

<div className="rich-text"><p>Of course, I’m referring to a meaningful investment in the front line sales &amp; marketing operations, and how a business specifically addresses its target customers, and then aligns with the new buying journey. At its simplest, this is what SE is all about. For far too long we have expected individual sales people to make the necessary adjustments (as markets evolve) but there are two key problems with that logic:</p><ul><li>Sales people are now under too much pressure (with circa 63% under-performing according to HBR 2016), and they are running too hard at increasing quotas to ever take their blinkers off and actually look up.</li><li>If we don’t change how we measure, manage and reward sales people then they will NOT change their ingrained behaviors. <a href="http://www.ou.edu/russell/UGcomp/Kerr.pdf">The folly of rewarding behavior A and expecting behavior B. </a></li></ul><p>So, what’s needed is for senior management to take the leap of faith and actually invest in some ‘sales enablement’ basics that can span the following increasingly important elements:</p><ul><li><strong>Market Analysis</strong> – SE, when done right, always begins with some detailed analysis of the external environment – customers, segments, competitors, emerging trends, driving forces of change etc. Journey mapping, and alignment with the customers new buying journey is of course critical.</li><li><strong>Bench-marking </strong>- Benchmark and baseline current sales performance against industry best practices. This will provide the gap analysis that hopefully will guide decision making on where you are today, versus where you need to be tomorrow and beyond. Current versus Future state.</li><li><strong>On-boarding –</strong> having written a recent post on the <a href="http://bit.ly/2bJ5VId">importance of on-boarding</a>, I’m bemused (but not overly surprised) to learn that 60.7% of the CSO study participants reported a ramp-up time of seven months or more. In 2016, this amount of time to ramp up a new sales person is utterly ridiculous - little wonder sales staff attrition rates are so high.</li><li><strong>Range Management</strong> - identifying the distance between your best and your worst performers has always been important, but the key question with range management is HOW to get your D-graders and C-graders closer towards B and A-grade performance levels?</li><li><strong>High Performance Culture and Industry Best Practices</strong> – by establishing a separate SE charter and function, businesses now have an ancillary benefit and a golden opportunity for some much needed cultural realignment. SE can provide the rationale, impetus and all of the market justification to force an organisational cultural change around <em>'customer centricity'</em>, and I have personally seen this done with great effect.</li><li><strong>Proactive Distraction Management</strong> – a nice way of saying that SE should absolutely remove the low value activities that sales people are required to perform on a daily basis, by removing the admin impost, and increasing their available selling time - restructure towards enabling genuine focus on high value activities.</li><li><strong>Cross-Functional Collaboration</strong> – with increasing product portfolio's stemming from M&amp;A activities its now critical for larger vendors to have a separate SE function that can bring that all important single customer view. My recent post outlining <a href="http://bit.ly/2bRdZYE">Team-Based Selling</a> highlights why this element of SE is so critical. As mentioned in the point above, the ancillary benefit with an overarching and cross functional SE program is cultural realignment – enterprise wide.</li></ul><p>So, if you are one of those business leaders that simply expects more revenue each year, then stop dreaming – you won’t get that result without paying some serious attention to (an investment in) SE. You must take a long hard look at the elements above that are lacking in your business and begin the process of reform. The good news is that SE is gaining traction, and according to CSO Insights, <em>“there is now a 50/50 split between companies that have implemented a formal structure around sales enablement and those that have not”.</em></p><p>Which side of the ledger are you on? Are you being left behind?</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/&amp;title=Sales%20Enablement%20is%20the%20key%3A&amp;summary=Sales%20Enablement%20is%20the%20key%3A&amp;source=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20Enablement%20is%20the%20key%3A&amp;url=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20Enablement%20is%20the%20key%3A&amp;body=https%3A//salestribe.com/knowledge-centre/insights/why-sales-enablement-key/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 